import React from 'react';
import { useParams } from 'react-router-dom';
import Article from './Article';
import { articlesContent } from '../../content/articles/ArticlesContent';
import Breadcrumbs from '../Breadcrumbs';
import { generateArticleBreadcrumbs } from '../../utils/breadcrumbHelpers';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { articlesCardData } from '../../content/articles/ArticlesCardData';
import { destinationCardData } from '../../content/destinations/DestinationCardData';

const BreadcrumbsContainer = styled(Container)`
  padding-top: 20px;
`;

const ArticleNavigationWrapper = () => {
  const { country, slug } = useParams();
  const content = articlesContent[slug || ''];
  const cardData = articlesCardData[country as keyof typeof articlesCardData];
  const articleData = cardData.find((item) => item.slug === slug);
  const { title, relatedArticlesSlugs = [] } = articleData ?? {};
  const relatedArticles = cardData.filter((item) =>
    relatedArticlesSlugs.includes(item.slug)
  );

  const desCardData =
    destinationCardData[country as keyof typeof destinationCardData];
  const relatedDestinations = desCardData.filter((item) =>
    relatedArticlesSlugs.includes(item.slug)
  );

  // Generate breadcrumbs only if both country and content exist
  const breadcrumbItems =
    country && title && slug
      ? generateArticleBreadcrumbs(country, title, slug)
      : [];

  return (
    <>
      <BreadcrumbsContainer>
        <Breadcrumbs items={breadcrumbItems} />
      </BreadcrumbsContainer>
      <Article
        backButtonLink={`/international/${country}`}
        content={content}
        relatedArticles={relatedDestinations.concat(relatedArticles)}
      />
    </>
  );
};

export default ArticleNavigationWrapper;
